import { useEffect } from "react";
import Seo from "@/components/Seo";
import { RookieOffer, RookieChecks } from "@/components/RookieOffer";

const SITE = "https://voluntoldhq.com";

export default function Rookie() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-[#F5F0EA]" data-testid="rookie-page">
      <Seo rawTitle="Free Rookie Coach Guide | VoluntoldHQ" brand="VoluntoldHQ" path="/rookie" image={`${SITE}/rookie/cover.png`}
        description="The free 15-minute guide to your first season: practice plan, parent meeting script, safety basics, and the rules that come up in week 1." />
      <RookieOffer source="rookie_page" as="h1" />
      <RookieChecks />
    </div>
  );
}
